import React, { ReactElement, useEffect, useState } from 'react';
import { formInitDataType } from './Pop';
import { Col, Form, Input, Select, InputNumber, DatePicker, Switch, Tooltip, Row, Space } from 'antd';

const ComForm = (props: any): ReactElement => {
    let data: formInitDataType = props.props
    const { form, formItem, onFinish } = data
    const [formItemData, setFormItemData] = useState<any>([])

    // 处理 input
    const inputItem = (item: any): ReactElement => {
        let rule = rules(item)
        const inputNode = (
            <Input
                allowClear={item.allowClear}
                variant={item.bordered === false ? 'borderless' : 'outlined'}
                defaultValue={item.defaultValue}
                id={item.id}
                maxLength={item.maxLength}
                prefix={item.prefix}
                size={item.size}
                suffix={item.suffix}
                type={item.type}
                value={item.value}
                onChange={item.onChange}
                onPressEnter={item.onPressEnter}
                disabled={item.disable}
            />
        )
        return (
            <Tooltip key={item.name} title={item.Tooltip && item.title ? item.title : null}>
                <Col key={item.name} span={item.col || 8}>
                    <Form.Item
                        label={item.label}
                        name={item.name}
                        key={item.name}
                        rules={rule}
                        required={item.required}
                    >
                        {item.addonBefore || item.addonAfter ? (
                            <Space.Compact style={{ width: '100%' }}>
                                {item.addonBefore && (
                                    <Input style={{ width: 'auto' }} disabled value={item.addonBefore} />
                                )}
                                {inputNode}
                                {item.addonAfter && (
                                    <Input style={{ width: 'auto' }} disabled value={item.addonAfter} />
                                )}
                            </Space.Compact>
                        ) : inputNode}
                    </Form.Item>
                </Col>
            </Tooltip>
        )
    }

    // 处理 Switch（无需改动）
    const SwitchC = (item: any): ReactElement => {
        let rule = rules(item)
        return (
            <Tooltip key={item.name} title={item.Tooltip && item.title ? item.title : null}>
                <Col key={item.name} span={item.col || 8}>
                    <Form.Item
                        label={item.label}
                        name={item.name}
                        key={item.name}
                        rules={rule}
                        valuePropName={item.valuePropName}
                        initialValue={item.initialValue}
                    >
                        <Switch
                            autoFocus={item.autoFocus}
                            checked={item.checked}
                            checkedChildren={item.checkedChildren}
                            className={item.className}
                            defaultChecked={item.defaultChecked}
                            disabled={item.disable}
                            loading={item.loading}
                            size={item.size}
                            onChange={item.onChange}
                            unCheckedChildren={item.unCheckedChildren}
                            onClick={item.onClick}
                        />
                    </Form.Item>
                </Col>
            </Tooltip>
        )
    }

    // 处理数字框
    const inputNumber = (item: any): ReactElement => {
        let rule = rules(item)
        const numberNode = (
            <InputNumber
                autoFocus={item.autoFocus}
                variant={item.bordered === false ? 'borderless' : 'outlined'}
                controls={item.controls}
                decimalSeparator={item.decimalSeparator}
                defaultValue={item.defaultValue}
                disabled={item.disable}
                formatter={item.formatter}
                keyboard={item.keyboard}
                max={item.max}
                min={item.min}
                parser={item.parser}
                precision={item.precision}
                readOnly={item.readOnly}
                prefix={item.prefix}
                size={item.size}
                stringMode={item.stringMode}
                value={item.value}
                onChange={item.onChange}
                onPressEnter={item.onPressEnter}
                onStep={item.onStep}
            />
        )
        return (
            <Tooltip key={item.name} placement={item.Tooltip ? item.placement : null} title={item.Tooltip ? item.title : null}>
                <Col key={item.name} span={item.col || 8}>
                    <Form.Item label={item.label} name={item.name} key={item.name} rules={rule}>
                        {item.addonBefore || item.addonAfter ? (
                            <Space.Compact style={{ width: '100%' }}>
                                {item.addonBefore && (
                                    <Input style={{ width: 'auto' }} disabled value={item.addonBefore} />
                                )}
                                {numberNode}
                                {item.addonAfter && (
                                    <Input style={{ width: 'auto' }} disabled value={item.addonAfter} />
                                )}
                            </Space.Compact>
                        ) : numberNode}
                    </Form.Item>
                </Col>
            </Tooltip>
        )
    }

    // 处理 DatePicker（无需改动）
    const datePicker = (item: any): ReactElement => {
        let rule = rules(item)
        return (
            <Tooltip key={item.name} title={item.Tooltip && item.title ? item.title : null}>
                <Col key={item.name} span={item.col || 8}>
                    <Form.Item
                        label={item.label}
                        name={item.name}
                        key={item.name}
                        rules={rule}
                        initialValue={item.initialValue}
                    >
                        <DatePicker
                            defaultPickerValue={item.defaultPickerValue}
                            defaultValue={item.defaultValue}
                            disabledTime={item.disabledTime}
                            format={item.format}
                            renderExtraFooter={item.renderExtraFooter}
                            showNow={item.showNow}
                            showTime={item.showTime}
                            showToday={item.showToday}
                            value={item.value}
                            onChange={item.onChange}
                            onOk={item.onOk}
                            onPanelChange={item.onPanelChange}
                        />
                    </Form.Item>
                </Col>
            </Tooltip>
        )
    }

    // 处理 Select
    const selectItem = (item: any): ReactElement => {
        let rule = rules(item)
        return (
            <Tooltip key={item.name} title={item.Tooltip && item.title ? item.title : null}>
                <Col key={item.name} span={item.col || 8}>
                    <Form.Item label={item.label} name={item.name} key={item.name} rules={rule}>
                        <Select
                            disabled={item.disable}
                            placeholder={item.placeholder}
                            showSearch={item.showSearch}
                            optionFilterProp={item.optionFilterProp}
                            filterOption={item.filterOption}
                            onSelect={item.onSelect}
                            autoClearSearchValue={item.autoClearSearchValue}
                            autoFocus={item.autoFocus}
                            variant={item.bordered === false ? 'borderless' : 'outlined'}
                            clearIcon={item.clearIcon}
                            defaultActiveFirstOption={item.defaultActiveFirstOption}
                            defaultOpen={item.defaultOpen}
                            defaultValue={item.defaultValue}
                            popupMatchSelectWidth={item.dropdownMatchSelectWidth}
                            popupRender={item.dropdownRender}
                            styles={{ popup: { root: item.dropdownStyle } }}
                            classNames={{ popup: { root: item.dropdownClassName } }}
                            fieldNames={item.fieldNames}
                            filterSort={item.filterSort}
                            getPopupContainer={item.getPopupContainer}
                            labelInValue={item.labelInValue}
                            listHeight={item.listHeight}
                            loading={item.loading}
                            maxTagCount={item.maxTagCount}
                            maxTagPlaceholder={item.maxTagPlaceholder}
                            maxTagTextLength={item.maxTagTextLength}
                            menuItemSelectedIcon={item.menuItemSelectedIcon}
                            mode={item.mode}
                            notFoundContent={item.notFoundContent}
                            open={item.open}
                            optionLabelProp={item.optionLabelProp}
                            options={item.options}
                            removeIcon={item.removeIcon}
                            searchValue={item.searchValue}
                            showArrow={item.showArrow}
                            size={item.size}
                            suffixIcon={item.suffixIcon}
                            tagRender={item.tagRender}
                            value={item.value}
                            virtual={item.virtual}
                            onBlur={item.onBlur}
                            onChange={item.onChange}
                            onClear={item.onClear}
                            onDeselect={item.onDeselect}
                            onOpenChange={item.onDropdownVisibleChange}
                            onFocus={item.onFocus}
                            onPopupScroll={item.onPopupScroll}
                            onSearch={item.onSearch}
                        >
                            {item.data !== undefined ? item.data : null}
                        </Select>
                    </Form.Item>
                </Col>
            </Tooltip>
        )
    }

    // 处理 Row（无需改动）
    const row = (Arr: Array<any>): ReactElement => {
        return <Row>{Arr}</Row>
    }

    // 规则（无需改动）
    const rules = (item: any): Array<any> => {
        let rules = [];
        if (item.required) {
            let message = item.message || `${item.label}不能为空`
            rules.push({ required: true, message })
        }
        if (item.rules && item.rules.length > 0) {
            rules = rules.concat(item.rules)
        }
        return rules
    }

    // 初始化（无需改动）
    const initFormItem = () => {
        if (!formItemData || (formItemData && formItemData.length === 0)) { return false }
        let rowList: any = []
        formItemData.map((item: any) => {
            if (item.type === "Input") rowList.push(inputItem(item))
            if (item.type === "Select") rowList.push(selectItem(item))
            if (item.type === "InputNumber") rowList.push(inputNumber(item))
            if (item.type === "DatePicker") rowList.push(datePicker(item))
            if (item.type === "Switch") rowList.push(SwitchC(item))
        })
        return row(rowList)
    }

    useEffect(() => {
        setFormItemData(formItem)
    }, [formItem])

    return (
        <>
            <Form form={form} onFinish={onFinish}>
                {initFormItem as any}
            </Form>
        </>
    )
}
export default ComForm